import React, { useRef } from 'react';

import { Grid, Paper, Typography } from '@material-ui/core';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { CloudDownload, CloudUpload } from '@material-ui/icons';
import moment from 'moment';

import { GenericTable } from '../organisms/GenericTable';
import { useFormNew } from '../../../hooks/useFormNew';
import { DatePickerGeneric } from '../atoms/DatePicker';
import { ButtonGeneric, ButtonSplitGeneric } from '../atoms/Buttons';
import { CustomDivider } from '../atoms/Divider';

const center = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
}

export const TemplateMigrateFiles = ({ 
    tableProps,
    list, 
    columns, 
    handleSearch = () => {}, 
    seekerList, 
    behindDates = {}, 
    title, 
    buttons = [],
    templateButtons = [],
    disabledSearch = () => false
}) => {
    const componentRef = useRef();
    
    const { formValues, setFormValues } = useFormNew({
        fechaDesde: moment(),
        fechaHasta: moment(),
        ...behindDates?.value,
        ...seekerList?.values
    });

    const onSubmit = (e) => {
        e.preventDefault();
        handleSearch({
            ...formValues,
            fechaDesde: moment(formValues.fechaDesde).startOf('day').format('YYYY-MM-DDTHH:mm:ss'), 
            fechaHasta: moment(formValues.fechaHasta).endOf('day').format('YYYY-MM-DDTHH:mm:ss') 
        });
    };

    const searchList = [
        ...[seekerList?.list || []],
        ...(!!behindDates ? [
            {
                xs: 12,
                md: 6,
                Component: behindDates.Component(formValues, setFormValues),
            }
        ] : []),
        {
            xs: 12,
            md: !!behindDates ? 6 : 12,
            Component: (
                <Grid container spacing={0}>
                    {[
                        {
                            label: "Fecha Desde",
                            value: formValues.fechaDesde,
                            onChange: (date) => { setFormValues({ fechaDesde: date }) }
                        },
                        {
                            label: "Fecha Hasta",
                            value: formValues.fechaHasta,
                            onChange: (date) => { setFormValues({ fechaHasta: date }) }
                        }
                    ].map(({label, value, onChange}, index) => (
                        <Grid key={index} item xs={12} md={6} style={{border: "1px solid #ddd", padding: "0.5em"}}>
                            <DatePickerGeneric 
                                style={{padding: "0 1em"}}
                                value={value}
                                label={label}
                                onChange={onChange}
                                fullWidth
                                {...(index === 0) ? {maxDate: formValues.fechaHasta} : {minDate: formValues.fechaDesde}}
                            />
                        </Grid>
                    ))}
                </Grid>
            )
        },
        {
            xs: 12,
            Component: (
                <ButtonGeneric 
                    type="submit"
                    text="BUSCAR"
                    fullWidth
                    style={{borderRadius: 0}}
                    disabled={disabledSearch(formValues) || formValues.fechaDesde === null || formValues.fechaHasta === null}
                />
            )
        }
    ];

    const DefaultSeeker = () => {
        return (
            <Grid container spacing={0} alignItems='center'>
                {searchList.map(({ Component, xs, md = 12 }, index) => (
                    <Grid key={index} item xs={xs} md={md} style={{ border: "1px solid #ddd" }}>
                        { Component }
                    </Grid>
                ))}
            </Grid>
        )
    };

    return (
        <Grid container justify='center' style={{marginTop: "2em", gap: "1em"}}>
            <Grid item xs={6} md={5} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <ButtonSplitGeneric buttons={templateButtons.map(item => ({...item, icon: <CloudDownload />}))} />
            </Grid>
            <Grid item xs={6} md={5} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <div style={{ marginLeft: 'auto' }}>
                    <ButtonSplitGeneric fileType buttons={buttons.map(item => ({...item, icon: <CloudUpload />}))} />
                </div>
            </Grid>
            <Grid item xs={12} md={10}>
                <ValidatorForm onSubmit={onSubmit}>
                    <Grid component={Paper} elevation={2} style={{backgroundColor: "#eee"}}>
                        <Grid item xs={12} style={{...center, padding: "1em"}}>
                            <Typography variant='h6'>{title}</Typography>
                        </Grid>
                        <CustomDivider />
                        <Grid item xs={12}>
                            <DefaultSeeker />
                        </Grid>
                        <Grid item xs={12} component={Paper} elevation={2} square>
                            <GenericTable 
                                ref={componentRef}
                                align="center"
                                data={list}
                                columns={columns}
                                {...tableProps}
                            />
                        </Grid>
                    </Grid>
                </ValidatorForm>
            </Grid>
        </Grid>
    )
}